// extracted by mini-css-extract-plugin
export default {"asideCefX":"styles_asideCefX__+-fRh","tiposDePontos":"styles_tiposDePontos__g12Yc","wrapper_tiposDePontos":"styles_wrapper_tiposDePontos__YiB3C","point":"styles_point__gV0Xv"};